import { SVGProps } from 'react';

const Heading6 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 12h8m-8 6V6m8 12V6m5 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0m0 0c0-2.5 1-4 3-6"
    />
  </svg>
);
export default Heading6;
